import {
  isIdentificationDocument,
  isRequired,
  hasMiniumLength,
  isBankAccount,
} from '@helpers/validator';

const schema = {
  doc_number: {
    type: 'select',
    errorMessage: ['errors.rut.select', 'errors.rut.invalid'],
    isValid: [
      (value) => isRequired(value),
      (value) => (hasMiniumLength(value, 8) ? isIdentificationDocument(value) : false),
    ],
  },
  finantial_institution_name: {
    type: 'select',
    errorMessage: ['errors.account.bank'],
    isValid: [(value) => isRequired(value)],
  },
  account_type: {
    type: 'select',
    errorMessage: ['errors.account.type'],
    isValid: [(value) => isRequired(value)],
  },
  account_number: {
    type: 'text',
    errorMessage: ['errors.account.validNumber'],
    isValid: [(value) => isBankAccount(value)],
  },
};

export default schema;
